import Vue from 'vue'
import Router from 'vue-router'
import oidcCallback from '@/components/common/oidcCallback'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '../store'

// var domain = "todoCenter";
var domain = "todoCenter";
if (getUrlKey("domain")) {
  domain = getUrlKey("domain");
}
// var solution = `${process.env.SOLUTION}`;
var solution = "default";
if (getUrlKey("solution")) {
  solution = getUrlKey("solution");
}
var terminal = "workflow";
var isMobile = getMobile();
if(isMobile) {
  terminal = "wechat";
}

document.title = "服务大厅";

Vue.use(Router)
Vue.prototype.$global = ()=>{
  return {
    domain,solution,terminal
  }
}

var router = new Router({
  mode: "history", //加上history之后本地build之后router不正常显示，所以先暂时注释
  base:window.commonApi.PATH?window.commonApi.PATH:'/',
  routes: [
    {
      path: '/',
      name: 'layout',
      redirect: '/workflow/index',
      component: resolve => require([`@/views/${domain}/${solution}/${terminal}/layout/index`], resolve),
      children:[
        {
          path: '/workflow/home',   //未登录首页
          name: 'home',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsTemplate`], resolve),
          meta:{
            isPublic:true,
          }
        },
        {
          path: '/workflow/appallHome',   //未登录全部事项页
          name: 'appallHome',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsAppAllTemplate`], resolve),
          meta:{
            isPublic:true,
          }
        },
        {
          path: '/workflow/index',
          name: 'apps',
          meta: {
            title: '服务大厅'
          },
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsTemplate`], resolve)
        },
        {
          path: '/workflow/appall',
          name: 'appall',
          meta:{},//声明
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsAppAllTemplate`], resolve)
        },
        {
          path: '/workflow/todo',
          name: 'todo',
          meta: {
            title: '我的申请'
          },
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsTodoTemplate`], resolve)
        },
        {
          path: '/workflow/apply',
          name: 'apply',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsApplyTemplate`], resolve)
        },
        {
          path: '/workflow/approval',
          name: 'approval',
          meta: {
            title: '我的申请'
          },
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsApprovalTemplate`], resolve)
        },
        {
          path: '/workflow/completed',
          name: 'completed',
          meta: {
            title: '已处理'
          },
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsCompletedTemplate`], resolve)
        },
        {
          path: '/workflow/mine',
          name: 'mine',
          meta: {
            title: '我的'
          },
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsMineTemplate`], resolve)
        },
        
        {
          path: '/workflow/doing',
          name: 'doing',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsDoingTemplate`], resolve)
        },
        {
          path: '/workflow/done',
          name: 'done',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsDoneTemplate`], resolve)
        },
        {
          path: '/workflow/flow_cc',
          name: 'flow_cc',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsCcTemplate`], resolve)
        },
        {
          path: '/workflow/favorite',
          name: 'favorite',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsFavoriteTemplate`], resolve)
        },
        {
          path: '/workflow/detail',
          name: 'detail',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsItemDetail`], resolve)
        },
        {
          path: '/workflow/gl/:glId',
          name: 'gl',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsGlTemplate`], resolve)
        },
        /*后添加的一些*/
        {
          path: '/workflow/entrust',
          name: 'weituo',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsEntrustTemplate`], resolve)
        },
        {
          path: '/workflow/about',
          name: 'about',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsAboutTemplate`], resolve)
        },
        {
          path: '/workflow/infos',
          name: 'infos',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsInfosTemplate`], resolve)
        },
        {
          path: '/workflow/manage',
          name: 'manage',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/contentsManageTemplate`], resolve)
        },
        {
          path: '/workflow/home',   //做登录跳转使用，可看oidcCallbacK
          name: 'home',
          component: resolve => require([`@/views/${domain}/${solution}/${terminal}/Home`], resolve)
        },
      ]
    },
    /*----------------------------*/
    {
      path: '/workflow/oidcCallback',
      name: 'oidcCallback',
      component: oidcCallback,
      meta:{
        isVuexOidcCallback: true,
        isPublic: true
      }
    },
    {
      path: '/signin-oidc-error',
      redirect:'/'
    },
  ],
})
function getMobile() {
  var flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if(flag === null) {
      return false;
  }else {
      return true;
  }
}
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        location.href
      ) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  );
}
// 需要有未登录界面得做设置
if (window.commonData.isPublice&&!getMobile()) {
  router.beforeEach((to, from, next) => {
    if (to.name == 'home' || to.name == 'appallHome'||to.redirectedFrom == '/') {
      var client_id=window.commonApi.SSO_KEY;
      var authority = window.commonApi.SSO_URL + "/oauth2";
      var key = "oidc.user:"+authority+":"+client_id;
      var token = localStorage.getItem(key);
      if (token) {
        next();
      } else if(to.name == 'apps'){
        next({path:"/workflow/home"});
      }else{
        next();
      }
    } else {
      let middle = vuexOidcCreateRouterMiddleware(store, 'oidcStore');
      middle(to, from, next);
    }
  })
} else {
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js